import { GrcNotify, NotifyType } from '@grc/ui-package';
import I18N from '../../i18n/interface';
import GetEquipments from './get-equipments';

type EquipmentDetails = {
  tenantId: string;
  equipmentTypeId: string;
  fetchData: any;
  localeData: I18N;
};

export default async function GetEquipmentsById({
  tenantId,
  equipmentTypeId,
  fetchData,
  localeData
}: EquipmentDetails) {
  try {
    const response = await GetEquipments({ tenantId, fetchData, localeData });

    if (response.length > 0) {
      const equipmentType = response.filter(
        (item: any) => item.id === equipmentTypeId
      );
      return equipmentType[0]?.equipmentTypeName;
    } else {
      GrcNotify({
        message: 'Failed to fetch equipment type details',
        status: NotifyType.Error
      });
    }
  } catch (error) {
    GrcNotify({
      message: localeData.FailedToFetchEquipmentTypeDetailsNetworkError,
      status: NotifyType.Error
    });
  }
  return [];
}
